import { render } from "./NoteDisplay.vue?vue&type=template&id=3f803ba2"
import script from "./NoteDisplay.vue?vue&type=script&lang=js"
export * from "./NoteDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__